import PuffLoader from "react-spinners/PuffLoader"

const LoadingPage = () => {
  return (
    <div className='flex justify-center items-center h-screen max-md:h-dvh'>
      <PuffLoader loading={true}/>
    </div>
  )
}

export default LoadingPage